<ag-task (goBackEvent)="goBackEvent.emit($event)" [isUrlMode]="isUrlMode" [selectedFeatureMode]="selectedFeatureMode" [sidebarEl]="featureComponentSidebarEl"
         [urlModeGoBackUrl]="urlModeGoBackUrl" class="full-height-container"
         id="task-component">
  <ng-template agClassifier="{{FeatureComponentMode.EDIT_ROW}}">
    <app-respondent-company-detail
      class="task-component-detail full-height-container"></app-respondent-company-detail>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.BULK_INCLUDE}}">
    <app-respondent-company-bulk (goBackEvent)="goBackEvent.emit($event)"
                                       [featureComponentMode]="FeatureComponentMode.BULK_INCLUDE"
                                       [selectedRows]="selectedRows"
                                       class="task-component-detail full-height-container"></app-respondent-company-bulk>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.UPLOAD}}">
    <app-respondent-company-bulk (goBackEvent)="goBackEvent.emit($event)"
                                       [featureComponentMode]="FeatureComponentMode.UPLOAD"
                                       class="task-component-detail full-height-container"></app-respondent-company-bulk>
  </ng-template>
</ag-task>
